export default {
  title: "Events",
  empty: "No public events yet.",
  homeEmpty: "Nothing found",
  kicker: "What’s on",
  homeSubtitle:
    "Lectures, exhibitions, workshops, and other events in the Leninka IP ecosystem for authors, researchers, and creative teams",
  homeExploreTitle: "Browse the full calendar",
  homeExploreHint: "Lectures, exhibitions, workshops — find an event for you",
  homeExploreCount: "{{count}} events in the catalog",
  homeExploreAria: "Go to all events",
  detail: "Event",
  register: "Register",
  registerDone: "You are registered",
  loginToRegister: "Sign in to register",
  status: "Status",
  when: "When",
  where: "Where",
  description: "Description",
  loadFailed: "Could not load events.",
  portal: {
    title: "Events portal",
    pageTitle: "Events dashboard",
    pageSubtitle: "Manage your events and moderation in one place.",
    pageSubtitleParticipant: "Find events and register to take part.",
    navAria: "Events dashboard sections",
    overview: "Overview",
    all: "All",
    mine: "My events",
    created: "Created",
    attendance: "Attendance",
    moderation: "Moderation",
    registrations: "Registrations",
    create: "Create",
    overviewTitle: "Dashboard overview",
    overviewSubtitle: "Choose a section to continue working with events.",
    createdHint: "Events you manage as an organizer",
    visitsHint: "Events you have applied to",
    totalCreated: "Total: {{count}}",
    goToSection: "Open section",
    createTitle: "New event",
    titleField: "Title",
    descriptionField: "Description",
    submit: "Create draft",
    submitReview: "Submit for review",
    emptyMine: "You have no events yet.",
    emptyModeration: "Moderation queue is empty.",
    emptyRegistrations: "No registrations.",
    approve: "Approve",
    reject: "Reject",
    forbidden: "You do not have permission to moderate.",
    emptyAttendance: "No events available for attendance.",
    checkIn: "Check in",
    checkOut: "Check out",
    searchPlaceholder: "Search by title",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortTitle: "By title",
    filters: "Programme filters",
    galleryTitle: "Gallery",
    galleryThumbAria: "Photo {{index}} of {{total}}",
    subtitles: {
      created: "Drafts and published events you manage.",
      create: "You can complete the draft and send it for review.",
      moderation: "Organizers' events awaiting publication.",
      registrations: "Events you have registered for.",
      attendance: "Mark who attended the event.",
      all: "Published events listing.",
    },
    statuses: {
      draft: "draft",
      pending_review: "in review",
      approved: "published",
      rejected: "rejected",
      cancelled: "cancelled",
    },
    columns: {
      title: "Event",
      status: "Status",
      when: "When",
      actions: "Actions",
      participant: "Participant",
      registered: "Registered",
    },
    openEvent: "Open event",
    rejectTitle: "Reject event",
    rejectMessage: "“{{title}}” will return to the organizer and will not be listed.",
  },
}